import { render, staticRenderFns } from "./SegmentedToggle.vue?vue&type=template&id=613caf91&scoped=true"
import script from "./SegmentedToggle.vue?vue&type=script&lang=js"
export * from "./SegmentedToggle.vue?vue&type=script&lang=js"
import style0 from "./SegmentedToggle.vue?vue&type=style&index=0&id=613caf91&prod&scoped=true&lang=css"
import style1 from "./SegmentedToggle.vue?vue&type=style&index=1&id=613caf91&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613caf91",
  null
  
)

export default component.exports